import type { Manifest } from "../../shared/snapshot-format";
import { SNAPSHOT_FORMAT } from "../../shared/snapshot-format";

export const DATA_ROOT = "/data";

let cached: Promise<Manifest> | undefined;

/** The Snapshot manifest shipped with this build. Fetched once per page load. */
export function loadManifest(): Promise<Manifest> {
  cached ??= fetchJson<Manifest>(`${DATA_ROOT}/manifest.json`).then((m) => {
    if (m.format !== SNAPSHOT_FORMAT) {
      throw new Error(`Snapshot format ${m.format} is not supported by this build (wants ${SNAPSHOT_FORMAT})`);
    }
    return m;
  });
  return cached;
}

export async function fetchJson<T>(url: string): Promise<T> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`${res.status} ${res.statusText} loading ${url}`);
  return (await res.json()) as T;
}
